<ng-container *ngIf="evaluateManagementMode">
  <div class="background-alerts-management" [class.active]="showAlertsManagement"
    (click)="toggleDesktopAlertsManagement()">
  </div>

  <div class="alerts-management-content" [class.active]="showAlertsManagement">

    <div *ngIf="isAlertList">
      <div class="header-alerts-management">
        <span class="title">
          {{'HEADER_MODULE.TITLES.MY_ALERTS'| transloco }}
        </span>
        <div class="icon-cont">
          <i aria-hidden="true" class="icon-close" (click)="toggleDesktopAlertsManagement()"></i>
        </div>
      </div>
      <app-user-alerts
        (toggleDesktopAlertsManagement)="toggleDesktopAlertsManagement()"
        (confirmDeleteAlertDesktop)="confirmDeleteAlertDesktop($event)"
        (updateAlert)="updateAlert($event)">
      </app-user-alerts>
    </div>

    <div *ngIf="showCreateUpdateForm">
      <app-alert-form 
        [directOnly]="directOnlyAlert" 
        [flightType]="flightType$ | async"
        [hiddenFlexDate]="this.hasAlertSelection"
        [isUpdateForm]="isUpdateForm"
        [price]="maxPriceAlert" 
        [departureDate]="(departureDateAlert$ | async)"
        [arrivalDate]="(arrivalDateAlert$ | async)"
        [arrivalPlace]="(arrivalNameAlert$ | async)"
        (createAlert)="createAlertEvent($event)" 
        (toggleConfirmFormEvent)="toggleUpdateAlertForm()">
      </app-alert-form>
    </div>

  </div>
</ng-container>

<ng-container *ngIf="isDeleteAlertMode">
    <div content>
      <app-confirm-delete-alert
        [isMobile]="false"
        (confirmDeleteAlert)="evaluateDeleteAlert($event)">
      </app-confirm-delete-alert>
    </div>
</ng-container>

<ng-container *ngIf="notifyAlertCreated">
  <app-alert-created-edited-modal
    [isCreated]="isCreated"
    (toggleNotification)="toggleAlertCreated($event)">
  </app-alert-created-edited-modal>
</ng-container>
